function clickMore() {
  var reviewsList = document.getElementsByClassName("review");
  var openReviewsList = Array.from(reviewsList).filter(review =>
    review.classList.contains("open")
  ).length;
  if (reviewsList.length) {
    if (reviewsList.length > openReviewsList) {
      let lastOpenReview;
      for (let review of reviewsList) {
        if (!lastOpenReview) {
          lastOpenReview = review.classList.contains("open") ? false : 1;
        }
        if (lastOpenReview && lastOpenReview < 3) {
          review.classList.add("open");
          lastOpenReview++;
        }
      }
    } else {
      let index = 0;
      for (let review of reviewsList) {
        if (index >= 1) {
          review.classList.remove("open");
        }
        index++;
      }
      document.getElementById("show-more-reviews").innerHTML = "More +";
      document
        .getElementById("reviews")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (
      reviewsList.length ===
      Array.from(reviewsList).filter(review =>
        review.classList.contains("open")
      ).length
    ) {
      document.getElementById("show-more-reviews").innerHTML = "Less -";
    }
  }
}

export default function setClickMore() {
  let clickMoreButton = document.getElementById("show-more-reviews");
  if (clickMoreButton) {
    clickMoreButton.addEventListener("click", clickMore);
  }
}
